// import React from "react";
// import Divider from "@mui/material/Divider";
// import { ActionButton } from "../components/buttons";
// import { SelectBox } from "../components/inputs";
// import Footer from "../components/Footer";

// export function Announcement() {
//     return (
//         <>
//             <div className="container-fluid top-navbar">
//                 <div className='row w-100 g-2'>
//                     <div className='mb-3 col-3 d-flex'>
//                         <ActionButton buttonName="New Lead" />
//                         <ActionButton buttonName={<i className="bi bi-download"></i>} />
//                         <ActionButton buttonName={<i className="bi bi-upload"></i>} />
//                         <ActionButton buttonName={<i className="bi bi-file-bar-graph"></i>} />
//                         <Divider orientation="vertical" className='TopNavBardivider' variant="middle" flexItem />
//                     </div>
//                     <div className='col-2'>
//                         <SelectBox selectName="Assigned" style={{ borderRadius: "5px", border: "1px solid #5C4FDD" }} />
//                     </div>
//                     <div className='col-2'>
//                         <SelectBox selectName="Status" style={{ borderRadius: "5px", border: "1px solid #5C4FDD" }} />
//                     </div>
//                     <div className='col-2'>
//                         <SelectBox selectName="Source" style={{ borderRadius: "5px", border: "1px solid #5C4FDD" }} />
//                     </div>
//                     <div className='col-3'>
//                         <input className="form-control InputBox" type="search" placeholder="Search" aria-label="Search" />
//                     </div>
//                 </div>
//                 <div>
                 
//                 </div>
//                 <Footer pageName="Annoucement" />
//             </div>
//         </>
//     );
// }


import React, {useEffect, useState} from "react";
import {ActionButton} from "../components/buttons";
import DynamicTable from "../components/DynamicTable";
import {columns} from "../helpers/tableData";
import {AnnouncementModal} from "../dialogs";
import {useDispatch} from "react-redux";
import {usePagination} from "../hooks";
import {$crud} from "../services/CrudFactory";
import {ConfirmationModal} from "../dialogs/ConfirmationModal";
import Typography from "@mui/material/Typography";

export const Announcement = () => {
    const dispatch = useDispatch();
    const [status, setStatus] = useState(null);
    const [idToRemove, setIdToRemove] = useState(null);
    const [announcements, setAnnouncements] = useState([]);
    const {limit, setLimit, page, setPage, total, setTotal} = usePagination();

    const retrieveAnnouncements = async () => {
        try {
            dispatch({
                type: "LOADER",
                loader: true
            });
            const {data} = await $crud.retrieve("web/announcements", {limit, page});
            return data;
        } catch (e) {
            dispatch({
                type: "SNACKBAR",
                snackBar: {type: "error", message: e.message}
            });
        } finally {
            dispatch({
                type: "LOADER",
                loader: false
            });
        }
    };

    const statusChange = async (id) => {
        try {
            dispatch({
                type: "LOADER",
                loader: true
            });
            const {type, message} = await $crud.post("create/web/status/announcement", {
                id
            });
            retrieveAnnouncements().then(res => {
                setAnnouncements(res.announcements);
            });
            dispatch({
                type: "SNACKBAR",
                snackBar: {type, message}
            });
        } catch (e) {
            dispatch({
                type: "SNACKBAR",
                snackBar: {type: "error", message: e.message}
            });
        } finally {
            dispatch({
                type: "LOADER",
                loader: false
            });
        }
    };


    const remove = async (id) => {
        try {
            dispatch({
                type: "LOADER",
                loader: true
            });
            const {type, message} = await $crud.post("delete/web/announcement", {id});
            dispatch({
                type: "SNACKBAR",
                snackBar: {type, message}
            });
            retrieveAnnouncements().then(res => {
                setAnnouncements(res.announcements);
                setTotal(res.total);
            });
            setIdToRemove(null);
        } catch (e) {
            dispatch({
                type: "SNACKBAR",
                snackBar: {type: "error", message: e.message}
            });
        } finally {
            dispatch({
                type: "LOADER",
                loader: false
            });
        }
    };
    
    useEffect(() => {
        retrieveAnnouncements().then(res => {
            setAnnouncements(res.announcements);
            setTotal(res.total);
        });
    }, [limit, page]);
    return (
        <>
            <div>
                <div className='row w-100 g-2'>
                    <div className='mb-3 d-flex'>
                        <ActionButton onClick={() => setStatus({})} buttonName="Add Announcement"/>
                    </div>
                </div>
            </div>
            <DynamicTable
                rows={announcements}
                columns={columns?.announcements}
                style={{maxHeight: "calc(100vh - 102px)"}}
                total={total}
                onDelete={(id) => {
                    setIdToRemove(id);
                }}
                onRowClick={() => {
                }}
                onStatusChange={(id) => {
                    statusChange(id);
                }}
                onEdit={(value) => {
                    setStatus(value);
                }}
                paginationProps={{
                    limit: limit,
                    page: page,
                    onChangeLimit: (limit) => setLimit(limit),
                    onChangePage: (page) => setPage(page),
                }}
            />
            <AnnouncementModal
                onSave={() => {
                    retrieveAnnouncements().then(res => {
                        setAnnouncements(res.announcements);
                        setTotal(res.total);
                    });
                }}
                title="Announcement"
                apiUrl="web/announcement"
                data={status}
                onClose={() => setStatus(null)}
                open={!!status}
            />
            <ConfirmationModal
                open={!!idToRemove}
                title="Remove Announcement"
                content={
                    <>
                        <Typography variant="subtitle1" >Removing Announcement may lead to
                            Data Insufficiency In Lead | Make Sure to assign
                            Another Announcement Ids To These Announcement Leads.</Typography>
                        <Typography variant="subtitle2" > Press &apos;Yes&apos; To Remove
                            anyway.</Typography>
                    </>
                }
                onClose={() => {
                    setIdToRemove(null);
                }}
                onOk={() => remove(idToRemove)}
            />
        </>
    );
};